import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { fetchMovie, clearMovie } from "./movieActions";
import { toggleLike } from "../likes/likesActions";
import { addToWishlist, removeFromWishlist } from "../wishlist/wishlistActions";
import DateTimePicker from "../watchlist/DateTimePicker";
import Spinner from "../../components/Spinner";

const MovieDetail = (props) => {
  const dispatch = useDispatch();
  const { data: movie, loading, error } = useSelector((s) => s.movie);
  const isLiked = useSelector(
    (s) => movie && !!s.likes.items[movie.imdbID]
  );
  const isWishlisted = useSelector(
    (s) => movie && !!s.wishlist.items[movie.imdbID]
  );
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    dispatch(fetchMovie(props.match.params.id));
    return () => dispatch(clearMovie());
  }, [dispatch, props.match.params.id]);

  if (loading) return <Spinner />;
  if (error) return <div className="container mt-5 text-center"><h4>{error}</h4></div>;
  if (!movie) return null;

  const poster =
    movie.Poster && movie.Poster !== "N/A"
      ? movie.Poster
      : "https://via.placeholder.com/300x450?text=No+Poster";

  return (
    <div className="container mt-4 mb-5">
      <div className="row">
        <div className="col-md-4">
          <img src={poster} alt={movie.Title} className="img-fluid rounded shadow" />
          <div className="mt-3 d-flex justify-content-around">
            <button
              className={`btn ${isLiked ? "btn-danger" : "btn-outline-danger"}`}
              onClick={() => dispatch(toggleLike(movie))}
            >
              <i className={`${isLiked ? "fas" : "far"} fa-heart`}></i>{" "}
              {isLiked ? "Liked" : "Like"}
            </button>
            <button
              className={`btn ${isWishlisted ? "btn-warning" : "btn-outline-warning"}`}
              onClick={() =>
                isWishlisted
                  ? dispatch(removeFromWishlist(movie.imdbID))
                  : dispatch(addToWishlist(movie))
              }
            >
              <i className={`${isWishlisted ? "fas" : "far"} fa-bookmark`}></i>{" "}
              {isWishlisted ? "Wishlisted" : "Wishlist"}
            </button>
            <button
              className="btn btn-outline-info"
              onClick={() => setShowPicker(true)}
            >
              <i className="fas fa-calendar-plus"></i> Plan
            </button>
          </div>
        </div>
        <div className="col-md-8">
          <h2 className="mb-1">{movie.Title}</h2>
          <p className="text-muted mb-3">
            {movie.Year} &bull; {movie.Rated} &bull; {movie.Runtime}
          </p>
          <div className="mb-3">
            {movie.Genre &&
              movie.Genre.split(", ").map((g) => (
                <span key={g} className="badge badge-secondary mr-2 p-2">
                  {g}
                </span>
              ))}
          </div>
          <div className="mb-3">
            {movie.imdbRating && movie.imdbRating !== "N/A" && (
              <span className="rating-badge">
                <i className="fas fa-star text-warning"></i> {movie.imdbRating}/10
              </span>
            )}
          </div>
          <p className="lead">{movie.Plot}</p>
          <ul className="list-unstyled movie-meta">
            <li><strong>Director:</strong> {movie.Director}</li>
            <li><strong>Writer:</strong> {movie.Writer}</li>
            <li><strong>Actors:</strong> {movie.Actors}</li>
            <li><strong>Released:</strong> {movie.Released}</li>
            {movie.Awards && movie.Awards !== "N/A" && (
              <li><strong>Awards:</strong> {movie.Awards}</li>
            )}
          </ul>
          <div className="mt-4">
            <Link to={`/movie/${movie.imdbID}/cast`} className="btn btn-primary mr-2">
              <i className="fas fa-users"></i> View Cast
            </Link>
            <a
              href={`https://www.imdb.com/title/${movie.imdbID}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-warning mr-2"
            >
              <i className="fab fa-imdb"></i> IMDB
            </a>
            <button className="btn btn-outline-light" onClick={() => props.history.goBack()}>
              <i className="fas fa-arrow-left"></i> Back
            </button>
          </div>
        </div>
      </div>

      {showPicker && (
        <DateTimePicker movie={movie} onClose={() => setShowPicker(false)} />
      )}
    </div>
  );
};

export default MovieDetail;
